export enum SentryEvents {
  SERVER_API_REQUEST_TIMING = 'server api request timing',
  SERVER_API_REQUEST_ERROR = 'server api request error',
}
